import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { theme } from "../../../styles/theme";
import { Col, Row, Div, Text } from "../../../styles/Common";
import { Card } from "../../../components/Card";
import {
  PhoneIcon,
  EmailIcon,
  PinIcon,
  ChevronRightIcon,
  EditIcon,
} from "../../../assets/icons";
import {
  AiOutlineCopy
} from "react-icons/ai";
import Tabs from "../../../components/Tabs";
import useGetProfileUserSummary from "../hooks/useGetProfileUserSummary";
import { calculateAge, dateFormat, getIdSurveyInternal, getIdSurveyStatusCompleted, getIdSurveyStatusIncomplete, getIdSurveyStatusOpen, getIdSurveyStatusPending, getUserInfo, saveTabChange, timeSkeleton } from "../../../utilities/helpers";
import { getLabelById } from "../../../utilities/helpers";
import useGetPhoneCode from "../../../core/hooks/useGetPhoneCode";
import { Skeleton, Tooltip } from "antd";
import toast from "react-hot-toast";
import useGetListSurveys from "../hooks/useGetListSurveys";
import useLazyGetUserProfile from "../../ProfileInfo/hooks/useLazyGetUserProfile";
import dayjs from "dayjs";
import useSaveSurveyAnswer from "../hooks/useSaveSurveyAnswer";
import { Select } from "../../../components/Select";
import { SurveyCard, SurveysSkeleton } from "./CardSurveyMyAccount";
import useGetSurveyStatus from "../../../core/hooks/useGetSurveyStatus";
import useGetSurveyType from "../../../core/hooks/useGetSurveyType";

export const MyAccount = ({ setEditMyAccount, isMobile, handleViewSurvey }) => {
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState("146");
  const [dataProfile, setDataProfile] = useState({});
  const [dataSurveys, setDataSurveys] = useState([]);
  const [panels, setPanels] = useState([]);
  const [surveyComplete, setSurveyComplete] = useState(0);
  const [surveyIncomplete, setSurveyIncomplete] = useState(0);
  const [surveyEarring, setSurveyEarring] = useState(0);
  const [surveyOpen, setSurveyOpen] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    saveTabChange("2");
  }, [])

  const { nameid } = getUserInfo();
  const getProfileUserSummary = useGetProfileUserSummary(nameid);
  const { data } = getProfileUserSummary;

  const getPhoneCode = useGetPhoneCode();
  const { data: dataPhonecode, isSuccess: isSuccessPhoneCode } = getPhoneCode;
  const [optionsCodes, setOptionsCodes] = useState([]);

  const {
    refetch: refetchUserProfile, 
  } = useLazyGetUserProfile(nameid);
  
  const getSurveys = useGetListSurveys(Number(nameid));

  const { data: dataListSurveys } = getSurveys;

  const saveSurveyAnswer = useSaveSurveyAnswer(Number(nameid), null, null, 150);

  const getSurveyStatus = useGetSurveyStatus();
  const getSurveyType = useGetSurveyType();
    
  const { data: dataSurveyStatus, isSuccess: isSuccessSurveyStatus } =
    getSurveyStatus;
  const [optionsSurveyStatus, setOptionsSurveyStatus] = useState([]);
  useEffect(() => {
    if (isSuccessSurveyStatus) {
      let listSurveyStatus = 
        dataSurveyStatus?.data?.result.length > 0 ? 
        dataSurveyStatus?.data?.result.map((item) => ({
          label: item.name,
          value: item.id,
          code: item.code
        })) : 
        [];
      setOptionsSurveyStatus(listSurveyStatus);
      setActiveKey(getIdSurveyStatusPending(listSurveyStatus).toString());
    }
  }, [dataSurveyStatus, isSuccessSurveyStatus]);

  const { data: dataSurveyType, isSuccess: isSuccessSurveyType } =
    getSurveyType;
  const [optionsSurveyType, setOptionsSurveyType] = useState([]);
  useEffect(() => {
    if (isSuccessSurveyType) {
      setOptionsSurveyType(
        dataSurveyType?.data?.result.map((item) => ({
          label: item.name,
          value: item.id,
          code: item.code
        }))
      );
    }
  }, [dataSurveyType, isSuccessSurveyType]);

  const filteredSurveys = useMemo(() => {
    let arr = [];
    if (!dataSurveys.length || !optionsSurveyType.length){ 
      arr = []
    } else {
      arr = dataSurveys.filter(survey => 
        survey.statusId === 1 && 
        survey.typeSurveyId === getIdSurveyInternal(optionsSurveyType) && 
        survey.default &&
        !survey.deleted
      );
    };
    setTimeout(() => {
      setIsLoading(false);
    }, timeSkeleton)
    return arr;
  }, [dataSurveys, optionsSurveyType]); 

  useEffect(() => {
    if (isSuccessPhoneCode) {
      setOptionsCodes(
        dataPhonecode?.data?.result.map((item) => ({
          label: item.code,
          value: item.id,
        }))
      );
    }
  }, [dataPhonecode, isSuccessPhoneCode]);

  useEffect(() => {
    if (dataListSurveys?.data?.result?.length > 0 && optionsSurveyStatus.length > 0 && optionsSurveyType.length > 0) {
      const listSurvey = dataListSurveys.data.result;
      const internalTypeId = getIdSurveyInternal(optionsSurveyType);

      let counts = {
        complete: 0,
        earring: 0,
        incomplete: 0
      };
  
      listSurvey.forEach(item => {
        if (item.typeSurveyId !== internalTypeId || item.deleted || !item.default) return;
        
        if (item.progress == getIdSurveyStatusPending(optionsSurveyStatus)) counts.earring++;
        if (item.progress == getIdSurveyStatusCompleted(optionsSurveyStatus)) counts.complete++;
        if (item.progress == getIdSurveyStatusIncomplete(optionsSurveyStatus)) counts.incomplete++;
      });
  
      const formatTabText = (text, count) => {
        return count > 0 ? `${text} (${count})` : text;
      };
  
      const newPanels = [
        {
          tab: formatTabText("Encuestas Disponibles", counts.earring),
          key: getIdSurveyStatusPending(optionsSurveyStatus).toString(),
        }
      ];
  
      if (counts.incomplete > 0) {
        newPanels.push({
          tab: formatTabText("Encuestas Incompletas", counts.incomplete),
          key: getIdSurveyStatusIncomplete(optionsSurveyStatus).toString(),
        });
      }
  
      newPanels.push({
        tab: formatTabText("Encuestas Completadas", counts.complete),
        key: getIdSurveyStatusCompleted(optionsSurveyStatus).toString(),
      });
  
      setPanels(newPanels);
      setSurveyComplete(counts.complete);
      setSurveyIncomplete(counts.incomplete);
      setSurveyEarring(counts.earring);
      setDataSurveys(listSurvey);
    }
  }, [dataListSurveys, optionsSurveyStatus, optionsSurveyType]);

  useEffect(() => {
    setDataProfile({
      phoneNumber: data?.data?.result?.phoneNumber,
      ind: getLabelById(data?.data?.result?.phoneCodeId, optionsCodes),
      email: data?.data?.result?.email,
      address: data?.data?.result?.address,
      name: data?.data?.result?.name,
      lastName: data?.data?.result?.lastName,
      userCode: data?.data?.result?.userId
    });
  }, [data]);


  const initials =
    dataProfile?.name && dataProfile?.lastName
      ? `${dataProfile?.name.charAt(0)}${dataProfile?.lastName.charAt(
          0
        )}`.toUpperCase()
      : "NN";

  const handleTabChange = (key) => {
    setActiveKey(key);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const copyToClipboard = (content) => {
    navigator.clipboard.writeText(content)
      .then(() => {
        toast.success(`¡ID copiado!`);
      })
      .catch((error) => {});
  }

  const onClickSurvey = async(data) => {
    if (data?.typeSurveyId === 150) {
      const { data: userProfileData, isSuccess: isSuccessUserProfile, } = await refetchUserProfile();
      if(isSuccessUserProfile && userProfileData?.data?.result[0]) {
        let dataUser = userProfileData?.data?.result[0] || {};
        const petsString = Array.isArray(dataUser?.pets) ? dataUser.pets.join(", ") : "";
        const hobbiesString = Array.isArray(dataUser?.hobbies) ? dataUser.hobbies.join(", ") : "";
        let objDataUser = {
          userId: dataUser?.userId,
          name: dataUser?.name,
          lastName: dataUser?.lastName,
          email: dataUser?.email,
          phone: dataUser?.phoneNumber,
          instagram: dataUser?.instagram,
          age: dataUser?.birthDate? calculateAge(dateFormat(dataUser?.birthDate)).toString(): "",
          birthdate: dateFormat(dataUser?.birthDate),
          address: dataUser?.address,
          instruction: dataUser?.instruction,
          zone: dataUser?.zone? dataUser?.zone.toString(): "",

          ind: dataUser?.phoneNumberCode,
          department: dataUser?.department,
          municipality: dataUser?.city,
          maps: dataUser?.exactAddress,
          
          maritalStatus: dataUser?.maritalStatus,
          gender: dataUser?.gender,
          
          role: dataUser?.roleHouseId,
          incomeRange: dataUser?.incomeRange,
          numberChildren: dataUser?.numberChildren,
          physicalActivities: dataUser?.frequencyActivitiesPhysical,
          profession: dataUser?.professions,
          
          isPregnant: dataUser?.isPregnant? "Si": "No",
          isInterestedTechnology: dataUser?.isInterestedTechnology? "Si": "No",
          householdRole: dataUser?.isBuyManagerHome? "Si": "No",
          isAlcoholConsume: dataUser?.isAlcoholConsume? "Si": "No",
          isTobaccoConsume: dataUser?.isTobaccoConsume? "Si": "No",
          pets: petsString, 
          hobbies: hobbiesString, 
        }

        saveSurveyAnswer.reset();
        saveSurveyAnswer.mutate(
            {
              surveyId: data.surveyId,
              status: 151,
              typeSurvey: 150,
              formData: {}
            },
            {
                onSuccess: (res) => {
                },
                onError: (err) => {
                }
            }
        );

        const queryParams = new URLSearchParams(objDataUser).toString();
        const surveyUrl = `${data.surveyUrl}?${queryParams}`;
        window.open(surveyUrl, '_blank');
      }
    } else {
      handleViewSurvey(data, "2");
    }
  }

  const getCountSurveyProgres = (key) => {
    let count = filteredSurveys.filter(survey => survey.progress == key && !survey.deleted).length;
    return count > 0 ? `(${count})` : "";
  }

  const verifyStatusSurvey = (status) => {
    let getStatus = panels.find((survey) => survey.key == status.toString());
    return getStatus;
  }

  return (
    <>
      <Div
        direction={!isMobile ? "row" : "column"}
        gap="17px"
        m={!isMobile ? "49px 0 136px 0" : "25px 0 150px 0"}
        align={isMobile && "center"}
      >
        <Col>
          <Card width={!isMobile ? "379px" : "326px"} height="auto" p="24px">
            <Row width="100%" justify="space-between" m="0 0 15px 0">
              <Div
                width="80%"
                height="51px"
                background={theme.colors.blue100}
                radius="26px"
                align="center"
                justify="left"
                gap="9px"
                p="4px"
              >
                <Div
                  width="42px"
                  height="42px"
                  radius="50px"
                  background={theme.colors.red}
                  align="center"
                  justify="center"
                  style={{cursor: 'pointer'}}
                  onClick={() => {copyToClipboard(dataProfile.userCode)}}
                >
                  <Tooltip title="Copiar ID">
                    <AiOutlineCopy color={theme.colors.white} size={22}/>
                  </Tooltip>
                </Div>
                <Text color={theme.colors.white} style={{fontWeight: 'bold'}}>
                  ID: {dataProfile.userCode}
                </Text>
              </Div>
              <Div
                height="40px"
                width="40px"
                radius="50px"
                background={theme.colors.blue100}
                border={`1px solid ${theme.colors.white}`}
                onClick={() => setEditMyAccount(true)}
                align="center"
                justify="center"
                style={{ cursor: "pointer" }}
              >
                <Tooltip title={"Editar usuario"}>
                  <EditIcon stroke={theme.colors.white} />
                </Tooltip>
              </Div>
            </Row>

            <Col align="center" gap="24px">
              <Div
                height="80px"
                width="80px"
                radius="50px"
                background={theme.colors.red}
                align="center"
                justify="center"
              >
                <Text
                  color={theme.colors.white}
                  weight={theme.fonts.weight.bold}
                  size={theme.fonts.size.h3}
                >
                  {initials}
                </Text>
              </Div>
              <Text
                size={theme.fonts.size.h4}
                color={theme.colors.white}
                weight={theme.fonts.weight.bold}
                mb={!isMobile ? "40px" : "25px"}
                style={{ width: !isMobile ? "331px" : "100%" }}
              >
                {dataProfile?.name?.split(" ")[0]}{" "}
                {dataProfile?.lastName?.split(" ")[0]}
              </Text>
              <Div
                width="296px"
                height="51px"
                background={theme.colors.blue100}
                radius="26px"
                align="center"
                justify="left"
                gap="9px"
                p="4px"
              >
                <Div
                  width="42px"
                  height="42px"
                  radius="50px"
                  background={theme.colors.red}
                  align="center"
                  justify="center"
                >
                  <PhoneIcon stroke={theme.colors.white} />
                </Div>
                <Text color={theme.colors.white}>
                  {dataProfile.ind} {dataProfile.phoneNumber}
                </Text>
              </Div>
              <Div
                width="296px"
                height="51px"
                background={theme.colors.blue100}
                radius="26px"
                align="center"
                justify="left"
                gap="9px"
                p="4px"
              >
                <Div
                  width="42px"
                  height="42px"
                  radius="50px"
                  align="center"
                  justify="center"
                  background={theme.colors.red}
                >
                  <EmailIcon stroke={theme.colors.white} />
                </Div>
                <Text
                  style={{ maxWidth: "calc(100% - 42px - 18px)" }}
                  color={theme.colors.white}
                  align="webkit-left"
                >
                  {dataProfile?.email}
                </Text>
              </Div>
              <Div
                width="296px"
                height="51px"
                background={theme.colors.blue100}
                radius="26px"
                align="center"
                justify="left"
                gap="9px"
                p="4px"
                style={{ textAlign: "left" }}
              >
                <Div
                  width="42px"
                  height="42px"
                  radius="50px"
                  background={theme.colors.red}
                  align="center"
                  justify="center"
                  style={{ minWidth: "42px" }}
                >
                  <PinIcon stroke={theme.colors.white} />
                </Div>
                <Text
                  color={theme.colors.white}
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "calc(100% - 42px - 18px)",
                  }}
                >
                  {" "}
                  {dataProfile?.address}
                </Text>
              </Div>
              <Text
                weight={theme.fonts.weight.bold}
                color={theme.colors.white}
                style={{ cursor: "pointer" }}
                mt="6px"
                onClick={() => navigate("/ResetPasswordPlatform")}
              >
                Cambiar de contraseña
              </Text>
            </Col>
          </Card>
        </Col>
        <Col>
          <Card
            width={!isMobile ? "775px" : "326px"}
            p="35px 35px 51px 38px"
          >
            <Row>
              <Text
                weight={theme.fonts.weight.bold}
                color={theme.colors.white}
                size={theme.fonts.size.h3}
                mb="24px"
              >
                Aumenta tus posibilidades
              </Text>
            </Row>
            <Row m="0 0 51px 0">
              <Text
                weight={theme.fonts.weight.semibold}
                color={theme.colors.white}
                size={theme.fonts.size.h6}
                style={{ lineHeight: "30px" }}
              >
                Completa las encuestas que tenemos a continuación y aumenta tus
                posibilidades de recibir la{" "}
                <span style={{ color: theme.colors.red }}>Pulpeybox.</span>{" "}
                <br />
                <br />
                Recuerda que estas preguntas nos ayudan a seleccionar los productos correctos de acuerdo a tu estilo y etapa de vida en la que estás actualmente.
              </Text>
            </Row>
            {!isMobile ? (
              <Div direction="row" m="0 0 15px 0">
                <Tabs
                  defaultActiveKey="146"
                  onChange={handleTabChange}
                  activeKey={activeKey}
                  size={theme.fonts.size.default}
                  gutter={42}
                  tabPosition="left"
                >
                  {panels.map((panel) => (
                    <Tabs.Panel tab={`${panel.tab}`} key={panel.key} />
                  ))}
                </Tabs>
              </Div>
            ) : (
              <Div m="0 0 20px 0">
                <Select
                  label="Filtrar encuestas:"
                  value={activeKey}
                  onChange={handleTabChange}
                  width={"258px"}
                  height={"45px"}
                  background={theme.colors.blue100}
                  options={panels.map(panel => ({
                    label: panel.tab,
                    value: panel.key,
                  }))}
                />
              </Div>
            )}
            <Div
              direction={!isMobile ? "row" : "column"}
              gap="21.3px"
              align={isMobile && "center"}
              style={{
                display: "flex",
                flexWrap: "wrap", 
                justifyContent: "flex-start", 
              }}
            >
              {isLoading ? 
                <SurveysSkeleton count={3} isMobile={isMobile} />:
                filteredSurveys.length === 0 ? (
                  <Text
                    weight={theme.fonts.weight.semibold}
                    color={theme.colors.white}
                    size={theme.fonts.size.h5}
                    style={{ lineHeight: "30px" }}
                  >No hay encuestas disponibles por ahora. ¡Pronto añadiremos más!</Text> 
                ) : ( 
                <>
                  {(filteredSurveys.map((survey) => ( 
                    (survey.progress == activeKey) &&
                    <SurveyCard
                      key={survey.surveyId}
                      survey={survey}
                      isMobile={isMobile}
                      onCardClick={() => onClickSurvey(survey)}
                      status={verifyStatusSurvey(survey.progress)}
                    />
                  )))}
                  {(surveyComplete === 0 && activeKey == getIdSurveyStatusCompleted(optionsSurveyStatus)) && (
                    <Text
                      weight={theme.fonts.weight.semibold}
                      color={theme.colors.white}
                      size={theme.fonts.size.h5}
                      style={{ lineHeight: "30px" }}
                    >No tienes encuestas completadas en este momento. ¡Sigue participando en futuras encuestas!</Text>
                  )}
                  {(surveyEarring === 0 && activeKey == getIdSurveyStatusPending(optionsSurveyStatus)) && (
                    <Text
                      weight={theme.fonts.weight.semibold}
                      color={theme.colors.white}
                      size={theme.fonts.size.h5}
                      style={{ lineHeight: "30px" }}
                    >No tienes encuestas pendientes en este momento. ¡Pronto agregaremos más!</Text>
                  )}
                  {/* {(surveyOpen === 0 && activeKey == "151") && (
                    <Text
                      weight={theme.fonts.weight.semibold}
                      color={theme.colors.white}
                      size={theme.fonts.size.h5}
                      style={{ lineHeight: "30px" }}
                    >No tienes encuestas abiertas en este momento. ¡Sigue participando en futuras encuestas!</Text>
                  )} */}
                </>
              )}
            </Div>
          </Card>
        </Col>
      </Div>
    </>
  );
};

MyAccount.propTypes = {
  setEditMyAccount: PropTypes.func,
  isMobile: PropTypes.bool,
  handleViewSurvey: PropTypes.func
};
